
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="w-full px-4 sm:px-6 lg:px-8" role="navigation" aria-label="Main navigation">
        <div className="flex justify-between items-center h-16">
          
          {/* Logo */}
          <div className="flex-shrink-0 min-w-0">
            <h1>
              <a href="/" className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 cursor-pointer whitespace-nowrap" style={{ fontFamily: '"Inter", sans-serif' }}>
                Alberto Rocha | Technology Ethicist | AI Governance Strategist
              </a>
            </h1>
          </div>

          {/* Navigation Links */}
          <div className="hidden lg:flex items-center space-x-6 ml-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              The Book
            </button>
            <button 
              onClick={() => scrollToSection('video')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Video
            </button>
            <button 
              onClick={() => scrollToSection('audio')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Audio
            </button>
            <button 
              onClick={() => scrollToSection('bio')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Bio
            </button>
            <button 
              onClick={() => scrollToSection('platform')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Platform
            </button>
            <button 
              onClick={() => scrollToSection('speaking')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Speaking
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              FAQs
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-600 hover:text-teal-600 transition-colors cursor-pointer ml-4 flex-shrink-0"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3">
            <button 
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              The Book
            </button>
            <button 
              onClick={() => scrollToSection('video')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Video
            </button>
            <button 
              onClick={() => scrollToSection('audio')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Audio
            </button>
            <button 
              onClick={() => scrollToSection('bio')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Bio
            </button>
            <button 
              onClick={() => scrollToSection('platform')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Platform
            </button>
            <button 
              onClick={() => scrollToSection('speaking')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Speaking
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              FAQs
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-gray-600 hover:text-teal-600 transition-colors cursor-pointer font-medium py-2"
            >
              Contact
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}
